var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",staticClass:"ec-container",attrs:{"frameborder":"0","allowusermedia":"","sandbox":"allow-same-origin allow-scripts","allow":"microphone"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa0119c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"audio":["src"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/englishCentral.vue
// module id = 1119
// module chunks = 2 46